import Hamburguer from "../../../assets/images/generico/Hamburguer";
import HeaderTimer from "../HeaderTimer/HeaderTimer";
import camelize from "../../../../global/utils/camelize";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import { getStrDate } from "../../../../global/utils/diasData";
import { useHistory } from "react-router";
import React, { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import "./HeaderbarHome.css";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../../global/context/Provider";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import { HeaderBarMainContainer, MenuContainerMobile } from "./localStyle";
import isIosNative from "../../../../global/utils/isIosNative";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import IconBlack from "_+_Portal/assets/images/generico/IconBack";

// const { Storage } = Plugins;

const HeaderbarHome = ({ turnos, onShowBurguerHandle, handleClickVolver }) => {
  const history = useHistory();
  const {
    turnosPacienteDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    tokenDispatch,
    selectDropDownDispatch,
    resetPortalContext,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, configState, resetGlobalContext } =
    useContext(GlobalContext);
  // const { resetAdminContext} = useContext(AdminContext);

  const [showDropPerfil, setShowDropPerfil] = useState(false);
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  const imgAvatar =
    authState.auth.data && authState.auth.data.paciente.imagenPerfil;

  const nameCamelized = () => {
    if (authState.auth.data) {
      let name = authState.auth.data.paciente.nombre;
      return camelize(name);
    }
  };

  const onHandleClickAvatar = () => {
    if (!showDropPerfil) {
      setShowDropPerfil(true);
    } else {
      setShowDropPerfil(false);
    }
  };

  const onHandleVerPerfil = () => {
    history.push("/perfil");
  };

  let config = localStorage.getItem("config");
  let opcResetContext = JSON.parse(config).opcResetContext;

  const onHandleSalir = () => {
    // if (authState.authTraza.data !== null) {
    //   wsPostLogoutTraza(authState.authTraza.data.id, {
    //     ingreso: false,
    //     sector: configState.config.data.sectorTurno,
    //   })(authDispatch);
    // }
    if (opcResetContext) {
      resetPortalContext(0);
      resetGlobalContext(0);
      history.push("/");
    } else {
      logoutApp(history)(authDispatch);
      tokenLogout(history)(tokenDispatch);
      resetTurnosPaciente()(turnosPacienteDispatch);
      resetLaboGrupo()(laboGrupoDispatch);
      resetEstudioGrupo()(estudioGrupoDispatch);
      resetListaFamiliares()(listaFamiliaresDispatch);
      resetDropdown()(selectDropDownDispatch);
    }
    localStorage.setItem("alertaActive", true);
  };

  return (
    <React.Fragment>
      <div
        className={`ptur-HeaderbarDiv-background ${
          !showDropPerfil ? "disable" : ""
        }`}
        onClick={onHandleClickAvatar}
      ></div>
      <HeaderBarMainContainer className="c-white" $isIos={iosInfo}>
        {turnos ? (
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        ) : (
          <div className="logoHeader">
            <img
              className="ptur-logoHeader"
              src={
                process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"
              }
              alt="logo"
            ></img>
          </div>
        )}
        <div className="ptur-RightMenu">
          <div className="ptur-headerBarHome-DiaHora">
            <p id="ptur-DiaResponsive" className="rb18m">
              {getStrDate(new Date())}
              <span className="ptur-timer">
                <HeaderTimer />
              </span>
            </p>
          </div>
          <div className="ptur-perfilMenu">
            <div
              onClick={onHandleClickAvatar}
              className="ptur-flechaAvatar-box"
            >
              <div className="ptur-perfilMenu-perfilImg-box">
                <img
                  className={
                    showDropPerfil
                      ? `ptur-perfilMenu-perfilImg-img clickedAvatar`
                      : `ptur-perfilMenu-perfilImg-img`
                  }
                  src={
                    imgAvatar
                      ? `data:image/jpeg;base64,${imgAvatar}`
                      : defaultPerfil
                  }
                  alt="Perfil"
                />
              </div>

              <div style={{ position: showDropPerfil && "relative" }}>
                <div className="profile-container">
                  <div
                    className={`profile-menu ${showDropPerfil ? "open" : ""}`}
                  >
                    <div className="menu-title">
                      <div className="boxImg">
                        <img
                          className={`roundedImg`}
                          src={
                            imgAvatar
                              ? `data:image/jpeg;base64,${imgAvatar}`
                              : defaultPerfil
                          }
                          alt="Perfil"
                        />
                      </div>
                      <div>
                        <p className="rb16m c-latex10">{nameCamelized()}</p>
                        <p className="rb12l c-latex10 truncated-text">
                          {authState?.auth?.data?.paciente?.email}
                        </p>
                      </div>
                    </div>
                    <div className="menu-item" onClick={onHandleVerPerfil}>
                      <span className="rb14l">Mi Perfil</span>
                    </div>
                    <hr className="lineaSeparadora" />
                    <div className="menu-item" onClick={onHandleSalir}>
                      <span className="rb14l">Cerrar Sesión</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={onShowBurguerHandle}
            className="ptur-burguerPerfil pointer"
          >
            <MenuContainerMobile>
              <Hamburguer />
            </MenuContainerMobile>
          </div>
        </div>
      </HeaderBarMainContainer>
    </React.Fragment>
  );
};

export default HeaderbarHome;
